import { api } from "@/api";

export const deleteAllMonitorErrors = async (): Promise<{ deleted: number }> => {
  const res = await api.client.delete("/monitor/errors");
  return res.data;
};
